"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_179)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_179`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 12V23.9998H-6V12H12Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 0.000244141V12H12V0.000244141H30Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.00002 2.65082L3.83139 5.20942H6.52176L4.34524 6.79082L5.17654 9.34943L3.00002 7.7681L0.823491 9.34943L1.6548 6.79082L-0.521729 5.20942H2.16864L3.00002 2.65082Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21 14.6506L21.8314 17.2092H24.5218L22.3452 18.7906L23.1765 21.3492L21 19.7679L18.8235 21.3492L19.6548 18.7906L17.4783 17.2092H20.1686L21 14.6506Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_179`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PAFlag };
